import { Pipe, PipeTransform } from '@angular/core';
import {
  ReportStatus,
  ReportStatusOption,
} from '../../../../shared/enums/report-status.enum';

@Pipe({
  name: 'statusBadgeClass',
  standalone: true,
})
export class StatusBadgeClass implements PipeTransform {
  transform(status: ReportStatusOption): string {
    switch (status.key) {
      case ReportStatus.PENDING:
        return 'status-badge status-ordered';
      case ReportStatus.COMPLETED:
        return 'status-badge status-generated';
      case ReportStatus.FAILED:
        return 'status-badge status-error';
      default:
        return 'status-badge';
    }
  }
}
